 




document.addEventListener("DOMContentLoaded", function () {
  // === MARQUEE ===
  const marquee = document.getElementById('marquee');
  const content = document.getElementById('marqueeContent');

  if (marquee && content) {
    // Clone the content instead of duplicating innerHTML to avoid ID duplication issues
    const clone = content.cloneNode(true);
    content.appendChild(clone);

    let speed = 0.5;
    let pos = 0;
    let paused = false;

    function animate() {
      if (!paused) {
        pos -= speed;
        if (pos <= -content.scrollWidth / 2) pos = 0;
        content.style.transform = `translateX(${pos}px)`;
      }
      requestAnimationFrame(animate);
    }

    marquee.addEventListener('mouseenter', () => paused = true);
    marquee.addEventListener('mouseleave', () => paused = false);

    animate();
  }

  // === FADE-IN ON SCROLL ===
  const elements = document.querySelectorAll('.fade-in');
  let isVisibleArray = Array(elements.length).fill(false);
  let isCategoryHeaderVisible = false;

  function checkIfVisible() {
    elements.forEach((element, index) => {
      const elementTop = element.getBoundingClientRect().top;
      const elementBottom = element.getBoundingClientRect().bottom;
      const isVisibleNow = elementTop < window.innerHeight && elementBottom >= 0;

      if (isVisibleNow && !isVisibleArray[index]) {
        element.classList.add('fade-in-visible');
        isVisibleArray[index] = true;
      }
    });

    const categoryHeader = document.querySelector('.category-header');
    if (categoryHeader && !isCategoryHeaderVisible) {
      const top = categoryHeader.getBoundingClientRect().top;
      const bottom = categoryHeader.getBoundingClientRect().bottom;
      const isVisibleNow = top < window.innerHeight && bottom >= 0;

      if (isVisibleNow) {
        categoryHeader.classList.add('category-header-visible');
        isCategoryHeaderVisible = true;
      }
    }
  }

  // Debounced scroll for performance
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkIfVisible, 50);
  });

  // Check on load
  window.addEventListener('load', checkIfVisible);

  // === TOP BANNER SLIDE-IN ANIMATION ===
  const ribbon = document.querySelector('.top-delivery-banner');
  const slides = document.querySelectorAll('.slide');
  let activeSlideIndex = 0;
  let firstSlideAnimated = false;

  if (ribbon) {
    setTimeout(() => ribbon.classList.add('animate'), 200);
    setTimeout(() => ribbon.classList.add('in-view'), 2000);
    setTimeout(() => ribbon.classList.add('fade-in'), 4000);
  }

  if (slides.length > 0) {
    setInterval(() => {
      slides[activeSlideIndex].classList.remove('active');
      activeSlideIndex = (activeSlideIndex + 1) % slides.length;
      slides[activeSlideIndex].classList.add('active');

      if (activeSlideIndex === 0 && !firstSlideAnimated) {
        slides[activeSlideIndex].classList.remove('slide-first');
        firstSlideAnimated = true;
      }
    }, 5000);
  }
}); 
